import React from 'react';

/**
 * BlogBlockquote - External quote styling with attribution
 * Use for quotes from other sources, testimonials, etc.
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Quote content
 * @param {string} [props.author] - Quote author
 * @param {string} [props.title] - Author's title/role
 */
export const BlogBlockquote = ({ children, author, title }) => {
  return (
    <blockquote 
      className="mt-8 mb-8 pl-6 py-4 border-l-4 border-[#00E87A] bg-[#1A1A1A] rounded-r-lg"
      data-testid="blog-blockquote"
    >
      <p className="text-gray-200 italic">
        {children}
      </p>
      {(author || title) && (
        <cite className="text-gray-400 text-sm mt-3 block not-italic">
          {author && <span>— {author}</span>}
          {author && title && ', '}
          {title && <span>{title}</span>}
        </cite>
      )}
    </blockquote>
  );
};

export default BlogBlockquote;
